import {
  Linking,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../../components/Image';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { dining_white } from '../../assets/base64';
import { Footer } from '../../components/Footer';
import BookingTableForm from './components/BookingTableForm';
import PageTitle from '../../components/PageTitle';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { DinningLayout } from '../../WebLayout';
import { FONTS } from '../../constants';
import { IFormData } from '../../components/FormHelper/FormHelper.types';
import DiningApi from '../../services/api/dining.api';
import { Alert } from '../../services/alert';
import { Loading } from '../../components';
import OptionsApi from '../../services/api/options.api';

const GrillRoom: FC = () => {
  const isDesktop = useIsDesktop();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [banner, setBanner] = useState<string>();
  const [isLoadingBanner, setIsLoadingBanner] = useState<boolean>(true);

  const onSubmitHandler = useCallback(async (data: IFormData) => {
    setIsLoading(true);
    const submitData = {
      date: `${data.date} ${data.time}:00`,
      venue: data.venue,
      adults: data.nAdults,
      children: data.nChildren,
      comments: data.request,
    };
    let bookingInfo = `Thank you for your reservation! We have received your enquiry and a confirmation email will be sent to you shortly. If you do no hear with us within 24 hours, you may contact us directly at Ph. 3473 7169. Venue: ${data.venue}  Date: ${data.date} Time: ${data.time}:00`;

    DiningApi.postDiningRequest(submitData)
      .then((res) => {
        Alert.alert('Success', bookingInfo);
      })
      .catch((error) => {
        Alert.alert('Booking Alert', error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const getBanner = useCallback(async () => {
    try {
      setIsLoadingBanner(true);
      const res = await OptionsApi.getOptions();
      setBanner(res.data.fields.dining_banner?.url);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoadingBanner(false);
    }
  }, []);

  useEffect(() => {
    getBanner();
  }, [getBanner]);

  if (isDesktop()) {
    return (
      <DinningLayout
        title="Dining Reservation"
        icon={
          IS_WEB
            ? addBase64Prefix(dining_white)
            : require('../../assets/dining_white.png')
        }
        current={0}
      >
        <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
          <Image
            source={{
              uri: banner,
            }}
            style={{
              width: 400,
              height: 230,
              resizeMode: 'cover',
              marginRight: 20,
            }}
          />
        </View>
        <View style={{ marginTop: 20 }}>
          <BookingTableForm onSubmitHandler={onSubmitHandler} />
        </View>
        {isLoading === true && <Loading isFullScreen={true} />}
      </DinningLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Dining Reservation"
          icon={
            IS_WEB
              ? addBase64Prefix(dining_white)
              : require('../../assets/dining_white.png')
          }
          haveGoBackButton={true}
        />
      </View>
      <View style={[styles.container, { marginBottom: 20 }]}>
        <Image
          source={{
            uri: banner,
          }}
          style={{
            width: '100%',
            height: 230,
            resizeMode: 'cover',
          }}
        />
      </View>
      <View style={styles.container}>
        <BookingTableForm onSubmitHandler={onSubmitHandler} />
      </View>
      <Footer />
      {isLoading === true && <Loading isFullScreen={true} />}
    </ScrollView>
  );
};

export default GrillRoom;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  text: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 14,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  menuIcon: {
    width: 20,
    height: 28,
    resizeMode: 'contain',
    tintColor: STYLE_VARS.primaryColor,
    marginRight: 5,
  },
});
